import React, { useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { isNullOrUndefined } from "utils";
import { ClipboardIcon } from "assets";
import { getScorecardDataCellDetails, ScorecardDocument } from "api";
import { useNotify } from "hooks";
import { AttachedDocsModal } from "../../modals";

interface AttachedDocsButtonProps {
    dataId: number;
    hasDocuments?: boolean;
    disabled?: boolean;
}

export const AttachedDocsButton: React.FC<AttachedDocsButtonProps> = ({
    dataId,
    hasDocuments = false,
    disabled = false,
}) => {
    const notify = useNotify();
    const [isDocsModalOpen, setIsDocsModalOpen] = useState(false);
    const [documents, setDocuments] = useState<ScorecardDocument[]>([]);

    const handleOpenDocsDialog = async () => {
        if (disabled || isNullOrUndefined(dataId)) return;

        if (hasDocuments) {
            try {
                const cellDetails = await getScorecardDataCellDetails(dataId);
                setDocuments(cellDetails.documents);
            } catch (error: any) {
                notify.error(error?.response?.data || 'Failed to fetch cell detailss');
                setDocuments([]);
            }
        }
        setIsDocsModalOpen(true);
    };

    const handleCloseDocsDialog = () => {
        setIsDocsModalOpen(false);
    };

    return (
        <>
            <Tooltip arrow placement="top" title="Attached Documents">
                <IconButton
                    sx={{
                        width: "20px",
                        height: "20px",
                        padding: 0,
                        "&:hover": {
                            backgroundColor: "rgba(5, 66, 84, 0.1)",
                        },
                    }}
                    onClick={(e) => {
                        e.stopPropagation();
                        handleOpenDocsDialog();
                    }}
                    disabled={disabled}
                >
                    <ClipboardIcon style={{
                        width: "16px",
                        height: "15px",
                        color: disabled ? "#9CA3AF" : (hasDocuments ? "#46A314" : "#054254")
                    }} />
                </IconButton>
            </Tooltip>

            {isDocsModalOpen && (
                <AttachedDocsModal
                    isDialogOpen={isDocsModalOpen}
                    onDialogClose={handleCloseDocsDialog}
                    dataId={dataId}
                    documents={documents}
                    onUploadSuccess={() => {
                        handleOpenDocsDialog();
                    }}
                />
            )}
        </>
    );
};
